import { render, staticRenderFns } from "./shopProducts.vue?vue&type=template&id=3979a1f0"
import script from "./shopProducts.vue?vue&type=script&lang=js"
export * from "./shopProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports